import { render } from "./WeekdaysSelect.vue?vue&type=template&id=1a12944b&scoped=true&ts=true"
import script from "./WeekdaysSelect.vue?vue&type=script&lang=ts"
export * from "./WeekdaysSelect.vue?vue&type=script&lang=ts"

import "./WeekdaysSelect.vue?vue&type=style&index=0&id=1a12944b&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a12944b"]])

export default __exports__